module.exports = __webpack_public_path__ + "img/2U.1.d0744cbb.jpg";